// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".discount-timer[data-v-b09313c0]{display:flex;align-items:center;gap:4px;width:fit-content;height:30px;padding:6px;background:linear-gradient(99.32deg, #6d2ebd 7.83%, #ef4722 95.27%);border-radius:6px;font-family:var(--font-regular);font-size:14px;color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
